// ================================================================
// Gender Constants and Utilities
// Following established pattern for constants with helper functions
// ================================================================

/**
 * Gender options for dropdowns and form selections
 */
export const GENDER_OPTIONS = [
  { value: "", label: "Not specified" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
  { value: "prefer_not_to_say", label: "Prefer not to say" }
];

/**
 * Gender value to display label mapping
 */
export const GENDER_LABELS: Record<string, string> = {
  "male": "Male",
  "female": "Female",
  "other": "Other",
  "prefer_not_to_say": "Prefer not to say"
};

/**
 * Helper functions for gender management
 */
export const GenderUtils = {
  /**
   * Get display label from gender value
   */
  getGenderLabel: (value: string | null | undefined): string => {
    if (!value || value === "") return "Not specified";
    return GENDER_LABELS[value] || value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, ' ');
  },

  /**
   * Get all gender options for dropdowns
   */
  getGenderOptions: () => {
    return [...GENDER_OPTIONS];
  },

  /**
   * Validate gender value
   */
  isValidGender: (value: string): boolean => {
    return value in GENDER_LABELS;
  }
};
